import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import {
    AddCircleOutlineTwoTone,
    AddCircleTwoTone,
    Delete,
    GetAppTwoTone,
    HighlightOffTwoTone
} from "@material-ui/icons";
import {NotificationContainer, NotificationManager} from "react-notifications";
import { t } from '../../i18n';
import * as CommonUtils from "../../util/CommonUtils";
import {BlueButton, GreenButton, GreyButton, OrangeButton, RedButton} from "../common/ButtonsConstants";
import {Spinner} from "../common/Spinner";
import {downloadFile, uploadFile} from "../../util/ApiUtils";
import {
    deletePolicy,
    deletePolicyFile,
    policies,
    saveOrUpdatePolicy
} from "../../util/PoliciesApiUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

class Policies extends Component {
    constructor(props) {
        super(props);
        this.state = {
            policies: [],
            isLoading: true,
            isEditing: false,
            isNew: false,
            id: null,
            description: '',
            defaultLink: null,
            fileName: null,
            fileId: null,
            file: null,
        };
        this.loadPolicies = this.loadPolicies.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onFileSelect = this.onFileSelect.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onRemoveFile = this.onRemoveFile.bind(this);
    }

    componentDidMount() {
        this.loadPolicies();
    }

    loadPolicies() {
        policies()
            .then(response => {
                this.setState({
                    policies: response || [],
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                NotificationManager.error(t('app.notifications.error'), t('context.policies.messages.error'), 5000);
            });
    }

    onChange({ target }) {
        this.setState({ [target.name]: target.value });
    }

    onFileSelect(event) {
        const file = event.target.files[0];
        this.setState({ file });
    }

    onAdd() {
        this.setState({
            isEditing: true,
            isNew: true,
            id: null,
            description: '',
            defaultLink: null,
            fileName: null,
            fileId: null,
            file: null,
        });
    }

    onEdit(policy) {
        this.setState({
            isEditing: true,
            isNew: false,
            id: policy.id,
            description: policy.description || '',
            defaultLink: policy.defaultLink,
            fileName: policy.fileName,
            fileId: policy.fileId,
            file: null,
        });
    }

    onCancel() {
        this.setState({
            isEditing: false,
            isNew: false,
            id: null,
            description: '',
            defaultLink: null,
            fileName: null,
            fileId: null,
            file: null,
        });
    }

    onSave() {
        const { id, description, defaultLink, file } = this.state;
        if (!description || description.trim() === '') {
            NotificationManager.error(t('app.notifications.error'), t('context.policies.labels.description'), 5000);
            return;
        }
        const payload = { id, description, defaultLink };
        saveOrUpdatePolicy(payload)
            .then((saved) => {
                if (file) {
                    this.setState({ isLoading: true });
                    const callback = (status) => {
                        if (status === 200) {
                            NotificationManager.success(t('app.notifications.success'), t('context.policies.messages.fileUploaded'), 5000);
                        } else {
                            NotificationManager.error(t('app.notifications.error'), t('context.policies.messages.error'), 5000);
                        }
                        this.onCancel();
                        this.loadPolicies();
                    };
                    uploadFile("/policies/fileUpload", saved.id, file, callback);
                } else {
                    NotificationManager.success(t('app.notifications.success'), t('context.policies.messages.updatedSuccess'), 5000);
                    this.onCancel();
                    this.loadPolicies();
                }
            })
            .catch(error => {
                console.log(error);
                NotificationManager.error(t('app.notifications.error'), t('context.policies.messages.error'), 5000);
            });
    }

    onDelete(policy) {
        deletePolicy(policy)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('context.policies.messages.removedSuccess'), 5000);
                this.loadPolicies();
            })
            .catch(error => {
                console.log(error);
                NotificationManager.error(t('app.notifications.error'), t('context.policies.messages.error'), 5000);
            });
    }

    onRemoveFile() {
        if (!this.state.id) {
            this.setState({ file: null, fileName: null, fileId: null });
            return;
        }
        deletePolicyFile(this.state.id)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('context.policies.messages.fileRemoved'), 5000);
                this.setState({ file: null, fileName: null, fileId: null });
                this.loadPolicies();
            })
            .catch(error => {
                console.log(error);
                NotificationManager.error(t('app.notifications.error'), t('context.policies.messages.error'), 5000);
            });
    }

    renderFileCell(row, isDemo, isViewer) {
        if (row.fileId) {
            return (
                <Link href="#" onClick={(e) => { e.preventDefault(); downloadFile(row.fileId); }}>
                    <GetAppTwoTone /> {row.fileName}
                </Link>
            );
        }
        if (row.defaultLink && !isDemo && !isViewer) {
            return (
                <Link href={row.defaultLink} download>
                    <GetAppTwoTone /> {t('context.policies.defaultTemplate')}
                </Link>
            );
        }
        if (row.defaultLink) {
            return <span>{t('context.policies.defaultTemplate')}</span>;
        }
        return <span>{t('context.common.na')}</span>;
    }

    renderEditForm() {
        const { state } = this;
        return (
            <div style={{ paddingLeft: "30px", paddingRight: "30px", paddingBottom: "30px" }}>
                <Typography variant="h6" style={{ paddingTop: '20px' }}>
                    {state.isNew ? t('context.policies.newRecord') : t('context.policies.editRecord')}
                </Typography>
                <div style={{ paddingTop: "20px" }}>
                    <TextField
                        id="description"
                        name="description"
                        value={state.description}
                        label={t('context.policies.labels.description')}
                        onChange={this.onChange}
                        style={{ width: "600px" }}
                    />
                </div>
                <div className="form-group files" style={{ paddingTop: "30px" }}>
                    <Typography>{t('context.policies.labels.uploadedFile')}</Typography>
                    {state.fileName && state.fileId && (
                        <aside style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                            {state.fileName}
                            <GreyButton
                                onClick={() => downloadFile(state.fileId)}
                                style={{ marginLeft: '10px' }}
                            >
                                {t('common.download')}
                            </GreyButton>
                            <RedButton
                                onClick={this.onRemoveFile}
                                startIcon={<HighlightOffTwoTone />}
                                style={{ marginLeft: '10px' }}
                            >
                                {t('context.policies.removeFile')}
                            </RedButton>
                        </aside>
                    )}
                    {!state.fileName && state.defaultLink && (
                        <aside style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                            <Link href={state.defaultLink} download>
                                <GetAppTwoTone /> {t('context.policies.defaultTemplate')}
                            </Link>
                        </aside>
                    )}
                    <Typography style={{ paddingTop: '10px' }}>{t('context.policies.labels.uploadFile')}</Typography>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="file"
                        name="file"
                        onChange={this.onFileSelect}
                        type="file"
                    />
                </div>
                <div style={{ clear: "both", paddingTop: "20px" }}>
                    <OrangeButton
                        variant="contained"
                        color="secondary"
                        startIcon={<HighlightOffTwoTone />}
                        size="small"
                        onClick={this.onCancel}
                        style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px', float: "left" }}
                    >
                        {t('common.cancel')}
                    </OrangeButton>
                    <GreenButton
                        variant="contained"
                        color="secondary"
                        startIcon={<AddCircleTwoTone />}
                        size="small"
                        onClick={this.onSave}
                        style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                    >
                        {t('common.save')}
                    </GreenButton>
                </div>
            </div>
        );
    }

    render() {
        const { state } = this;
        if (state.isLoading) {
            return <Spinner />;
        }
        const isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        const isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        const isViewer = CommonUtils.isViewer(this.props.currentUser);
        const canEdit = !isAuditor && !isViewer;

        return (
            <div>
                <Typography component="h2" variant="h5">
                    {t('context.policies.title')}
                </Typography>
                <Paper className={classes.root} style={{ marginTop: '30px' }}>
                    {state.isEditing ? this.renderEditForm() : (
                        <div>
                            {canEdit && (
                                <div style={{ padding: '20px' }}>
                                    <BlueButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleOutlineTwoTone />}
                                        size="small"
                                        onClick={this.onAdd}
                                    >
                                        {t('context.policies.addNew')}
                                    </BlueButton>
                                </div>
                            )}
                            <Table className={classes.table} aria-label="policies table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><b>{t('context.policies.columns.description')}</b></TableCell>
                                        <TableCell><b>{t('context.policies.columns.file')}</b></TableCell>
                                        {canEdit && <TableCell />}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {state.policies.map(row => (
                                        <TableRow key={row.id}>
                                            <TableCell component="th" scope="row">{row.description}</TableCell>
                                            <TableCell>{this.renderFileCell(row, isDemo, isViewer)}</TableCell>
                                            {canEdit && (
                                                <TableCell align="right">
                                                    <GreenButton
                                                        variant="contained"
                                                        color="secondary"
                                                        startIcon={<Delete />}
                                                        size="small"
                                                        onClick={() => this.onEdit(row)}
                                                        style={{ marginRight: '10px' }}
                                                    >
                                                        {t('common.update')}
                                                    </GreenButton>
                                                    <RedButton
                                                        variant="contained"
                                                        color="secondary"
                                                        startIcon={<Delete />}
                                                        size="small"
                                                        onClick={() => this.onDelete(row)}
                                                    >
                                                        {t('common.delete')}
                                                    </RedButton>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    )}
                </Paper>
                <NotificationContainer />
            </div>
        );
    }
}

export default withStyles(classes)(Policies);
